import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateGroupActions } from "store/ducks/settings/groups";

export function* createGroupRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/groups`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateGroupActions.success(data));
    notify("success", "Perfil de Usuário cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateGroupActions.failure(errorMessage));
  }
}
